import { Reveal } from "./Reveal";
import { Star, ArrowUpRight, Quote } from "lucide-react";

const REVIEW_LINK = "https://g.page/r/CdvuvNufqQahEBM/review";

const testimonials = [
  {
    quote: "Showed up on time and my house looks brand new. The soft wash took years of grime off the siding. Highly recommend.",
    name: "Charleston Homeowner",
  },
  {
    quote: "Driveway and walkway came out spotless. Professional, fast, and fairly priced. Will be using them again.",
    name: "Verified Customer",
  },
];

export const Reviews = () => (
  <section id="reviews" className="py-24 sm:py-32 bg-fr-black border-t border-white/10" data-testid="reviews-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
        <div className="max-w-2xl">
          <span className="fr-mono text-xs tracking-[0.3em] uppercase text-fr-blue-light">/ Reviews</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
            Trusted by Charleston homeowners.
          </h2>
          <div className="mt-6 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={22} className="text-fr-blue-light fill-fr-blue-light" />
              ))}
            </div>
            <span className="text-white/60 fr-mono text-sm">Rated by our customers on Google</span>
          </div>
        </div>
        <a
          href={REVIEW_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="leave-review-btn"
          className="btn-primary inline-flex items-center gap-2 shrink-0 group"
        >
          Leave a Google Review
          <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
        </a>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6">
        {testimonials.map((t, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="bg-fr-surface border border-white/10 p-8 h-full hover:border-fr-blue/50 transition-colors duration-300" data-testid={`review-${i}`}>
              <Quote size={32} className="text-fr-blue-light mb-5" />
              <p className="text-white/80 text-lg leading-relaxed">{t.quote}</p>
              <div className="mt-6 flex items-center gap-2">
                <div className="flex">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={14} className="text-fr-blue-light fill-fr-blue-light" />
                  ))}
                </div>
                <span className="fr-mono text-xs tracking-widest uppercase text-white/50">{t.name}</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
